// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1ac79acb2a099c90f97b387ecbfc7e1274af7ca6.chunk.bundle.js";
};